module.exports = __webpack_public_path__ + "media/images/landing/icon-user-flow-0d5001d92355cbda63b21f61f1172f6b.svg";